import * as React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { LabelCountry, NotAllowedBlock } from "@components"
import { useBannersDetailsViewScreenshot } from "../../@hooks"


export default function retailerColumn() {
    return {
        name: "siteName", label: "Retailer",
        options: {
            customBodyRowRender: (value, row) => {
                const siteID = row.siteID
                const isAvailable = true

                return <Box textAlign="left">
                    <LabelCountry country={row?.market} label={value} />
                    <Box display="flex" flexDirection="column" gap={0}>
                        <Box display="flex" gap={.5}>
                            <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                                Section:
                            </Typography>
                            {row.sectionName}
                        </Box>
                        <Box display="flex" gap={.5}>
                            <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: "bold" }}>
                                Device:
                            </Typography>
                            {row.device}
                        </Box>
                    </Box>

                    <Typography variant="subtitle2">
                        {isAvailable ? <ViewScreenshotCell
                            icon="mobile"
                            target=""
                            searchID={row.searchID}
                        >
                            View Screenshot
                        </ViewScreenshotCell> : <NotAllowedBlock
                            text="Screenshot Not Available"
                            sx={{
                                block: {
                                    textAlign: "center",
                                    display: "inline-block",
                                    "&:hover div": { opacity: 1 }
                                }
                            }}
                        />}
                    </Typography>
                </Box>
            }
        }
    }
}

const ViewScreenshotCell = ({ icon, textProps, searchID, iconProps, children, ...props }) => {
    const { handleClick } = useBannersDetailsViewScreenshot()

    const onClick = () => handleClick(searchID)

    return  <Box component="span" {...props} onClick={onClick} sx={{ display: 'block', ...props?.sx }}>
        <Box {...textProps} sx={{ cursor: "pointer", ...textProps?.sx }}>
            { children }
            <IconSeeker icon={icon} {...iconProps} sx={{ mr: 0.5, margin: .5, ...iconProps?.sx }}/>
        </Box>
    </Box>
}